var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoodstuff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 18.5,
    r: 18.5,
    fill: "#7B61FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.106 28.1765L12.392 18.2941H25.636L24.922 28.1765H13.106ZM15.962 9.82353H22.024L25.944 13.6776L25.818 15.4706H12.168L12.042 13.6776L15.962 9.82353ZM33 13.2965L31.026 11.3059L28.8 13.5365L28.842 12.7459L23.2 7H14.8L9.158 12.7459L9.2 13.4518L6.974 11.2353L5 13.2682L9.522 17.6588L10.502 31H27.498L28.478 17.6729L33 13.2965Z",
    fill: "#E4EEFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodstuff);
export default __webpack_public_path__ + "static/media/foodstuff.909084c61cc761d6f07c191ab2fb3123.svg";
export { ForwardRef as ReactComponent };